module.exports = __webpack_public_path__ + "media/images/logo/logo_nissanrentalcar-d0540e98d4202eceb2fc37335425d798.png";